import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getCENSMEAutoComplete, CENSMEAutoCompleteModel } from "@tCentro/Services/CENSMEAutoCompleteService";

export interface GetCENSMEAutoCompleteParameter extends HasOnSuccess<CENSMEAutoCompleteModel> {
    query?: string;
}

type Props = GetCENSMEAutoCompleteParameter;

interface ReturnType {
    apiResult: CENSMEAutoCompleteModel;
}

type HandlerType = ApiHandler<Props, ReturnType>;

export const GetCENSMEAutoComplete: HandlerType = async props => {
    const result = await getCENSMEAutoComplete({ query: props.parameter.query ?? "" });

    if (props.parameter.onSuccess) {
        props.parameter.onSuccess(result);
    }
};

export const chain = [GetCENSMEAutoComplete];

const getCENSMEAutoCompleteData = createHandlerChainRunner(chain, "getCENSMEAutoCompleteData");
export default getCENSMEAutoCompleteData;
